import { I18n } from 'aws-amplify';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import { updatePanelInitData } from '@/component/multiPanel/panel/handler/PanelHandler';
import { getItemFieldListByFieldId } from '@/service/formManagementService';
import { makeStyles, Popover } from '@material-ui/core';
import { useEffect, useState } from 'react';
import './StatusUI.css';
import systemField from '../../../common/constant/SystemField';
import { PropTypes } from 'prop-types';

const renderStatusItemList = (itemList, setCurrentItemData, _setTicketStatusListPopover, currentItemData, setStatusNo = () => {}) => {
    let itemListConvert = [];

    const onClickHandler = itemId => {
        const currentItem = itemList.find(item => {
            return item.id === itemId;
        });
        const itemStructure = Utils.convertJSONDataToObject(currentItem.structure);
        setCurrentItemData({
            id: currentItem.id,
            name: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, currentItem.name),
            no: itemStructure.no,
            color: itemStructure.helpdesk?.color,
            background: itemStructure.helpdesk?.background
        });
        _setTicketStatusListPopover(null);
        setStatusNo(itemStructure.no)
    };

    if (!Utils.isEmptyArray(itemList)) {
        itemList?.forEach(item => {
            let itemStructure = Utils.convertJSONDataToObject(item.structure);
            if (itemStructure.no !== Constant.STATUS_NO.WAITING) {
                let itemData = {
                    id: item.id,
                    name: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, item.name),
                    no: itemStructure.no,
                    color: itemStructure.helpdesk?.color,
                    background: itemStructure.helpdesk?.background
                };
                itemListConvert.push(itemData);
            }
        });

        itemListConvert = itemListConvert.sort((a, b) => a.no - b.no);
    }

    return (
        <div className="status-item-list-content">
            {itemListConvert?.map(item => (
                <div key={`status-item-${item.id}`} className={item.id === currentItemData.id ? "status-item-wrap active" : "status-item-wrap"}>
                    <div
                        className="status-item-content"
                        key={`${item.id}`}
                        style={{
                            color: `${item.color}`,
                            background: `${item.background}`
                        }}
                        value={item.id}
                        onClick={e => {
                            onClickHandler(item.id);
                        }}
                    >
                        {item.name}
                    </div>
                </div>
            ))}
        </div>
    );
};

const StatusFieldUI = props => {
    const SHOW_STATUS_TICKET_TYPES = [
        Constant.TICKET_TYPE.TASK,
        Constant.TICKET_TYPE.EMAIL
    ];

    const SHOW_HELPDESK_CREATE_TICKET_TYPES = [
        Constant.HELPDESK_CREATE_TICKET_TYPE.TASK,
        Constant.HELPDESK_CREATE_TICKET_TYPE.EMAIL
    ];

    const [currentItemData, setCurrentItemData] = useState({});
    const [statusItemList, setStatusItemList] = useState([]);

    const [ticketStatusListPopover, setTicketStatusListPopover] = useState(null);
    const isTicketStatusListPopover = Boolean(ticketStatusListPopover);
    const idTicketStatusListPopover = isTicketStatusListPopover ? 'change-ticket-status' : '';

    const detailTicket = props.detailTicket;
    const createSelectTypeTicketHasStatus = SHOW_HELPDESK_CREATE_TICKET_TYPES.includes(props.selectTicketType);
    const isDraftTicketTask = detailTicket &&
        SHOW_STATUS_TICKET_TYPES.includes(detailTicket.ticketType) &&
        detailTicket.public === Constant.TICKET_PUBLIC.DRAFT;

    const checkTicketEnableEdit = () => {
        // Draft ticket deleted => Cannot edit
        if (isDraftTicketTask && detailTicket?.deletedAt) {
            return false;
        }

        if (createSelectTypeTicketHasStatus || isDraftTicketTask) {
            return !Utils.isEmptyString(props?.selectedAssigneeUserId);
        }

        if (
            detailTicket && (
                detailTicket.liveOrArchived === Constant.LIVE_OR_ARCHIVED.ARCHIVED ||
                (![Constant.TICKET_TYPE.TASK, Constant.TICKET_TYPE.EMAIL].includes(detailTicket.ticketType) && detailTicket.public === Constant.TICKET_PUBLIC.DRAFT) ||
                detailTicket.anonymousQaStatus === Constant.ANONYMOUS_TICKET_STATUS.WAITING_APPROVE ||
                detailTicket.anonymousQaStatus === Constant.ANONYMOUS_TICKET_STATUS.REJECTED ||
                props.isDisableEdit ||
                Utils.isAnonymousQAEndLiveChatTicket(detailTicket) ||
                detailTicket?.deletedAt
            )
        ) {
            return false;
        }

        if (!props.isHelpDesk) {
            return false;
        }

        return true;
    };

    useEffect(() => {
        (async () => {
            if (createSelectTypeTicketHasStatus) {
                let statusTaskItemList

                const fieldId = props.fieldData.id
                if (fieldId) {
                    statusTaskItemList = await getItemFieldListByFieldId(
                        props?.API,
                        Constant.FORM_USAGE.STATUS,
                        props?.fieldData?.affiliationOrganization,
                        fieldId
                    )
                    statusTaskItemList = statusTaskItemList.map(status => ({
                        ...status,
                        name: Utils.convertJSONDataToObject(status.name),
                        structure: Utils.convertJSONDataToObject(status.structure),
                        viewForCustomer: Utils.convertJSONDataToObject(status.viewForCustomer)
                    }))
                } else {
                    statusTaskItemList = systemField.filter(field => field.usage === Constant.FORM_USAGE.STATUS)
                }

                const initCurrentItem = (Utils.isEmptyString(props?.selectedAssigneeUserId) || props?.selectedAssigneeUserId === Constant.OPTION_UNASSIGNEE.KEY)
                    ? statusTaskItemList.find(item => item.structure.no === Constant.STATUS_NO.WAITING)
                    : statusTaskItemList.find(item => item.structure.no === Constant.STATUS_NO.TODO)
                setCurrentItemData({
                    ...initCurrentItem,
                    name: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, initCurrentItem.name),
                    no: initCurrentItem.structure.no,
                    background: initCurrentItem.structure.helpdesk.background,
                    color: initCurrentItem.structure.helpdesk.color
                })
                if (props.setStatusNo) {
                    const initStatusNo = initCurrentItem.structure.no
                    props.setStatusNo(initStatusNo)
                }
                return
            }
    
            const currentPanelInitData = props.currentPanelInitData;
            if (
                currentPanelInitData &&
                !Utils.isEmptyObject(currentPanelInitData) &&
                !props?.isEmail
            ) {
                if (currentPanelInitData.ticketStatus) {
                    let ticketStatus = currentPanelInitData.ticketStatus;
                    if (SHOW_STATUS_TICKET_TYPES.includes(detailTicket.ticketType)) {
                        ticketStatus = {
                            ...ticketStatus,
                            no: ticketStatus.no
                        };
                    }

                    setCurrentItemData(ticketStatus);
                }
                return;
            }
    
            setCurrentItemData({ ...props.currentItemData });
        })()
    }, [props.currentItemData, props.currentPanelInitData?.ticketStatus]);

    // handle change status when selected assignee (create/draft/edit ticket Task)
    useEffect(() => {
        (async () => {
            if (
                (
                    createSelectTypeTicketHasStatus || 
                    (detailTicket && SHOW_STATUS_TICKET_TYPES.includes(detailTicket.ticketType))
                ) &&
                !Utils.isEmptyObject(currentItemData)
            ) {
                const itemStructureNo = currentItemData.no;
                let updateStatusTodo =
                    itemStructureNo === Constant.STATUS_NO.WAITING &&
                    !Utils.isEmptyString(props?.selectedAssigneeUserId) &&
                    props?.selectedAssigneeUserId !== Constant.OPTION_UNASSIGNEE.KEY;
                let updateStatusWaiting =
                    itemStructureNo !== Constant.STATUS_NO.WAITING &&
                    !Utils.isEmptyString(props?.selectedAssigneeUserId) &&
                    props?.selectedAssigneeUserId === Constant.OPTION_UNASSIGNEE.KEY;

                if (updateStatusTodo || updateStatusWaiting) {
                    let statusTaskItemList
                    const fieldId = props.fieldData.id
                    if (fieldId) {
                        statusTaskItemList = await getItemFieldListByFieldId(
                            props?.API,
                            Constant.FORM_USAGE.STATUS,
                            props?.fieldData?.affiliationOrganization,
                            fieldId
                        )
                        statusTaskItemList = createSelectTypeTicketHasStatus
                            ? statusTaskItemList.filter(field => field.usage === Constant.FORM_USAGE.STATUS)
                            : statusTaskItemList

                        statusTaskItemList = statusTaskItemList.map(status => ({
                                ...status,
                                name: Utils.convertJSONDataToObject(status.name),
                                structure: Utils.convertJSONDataToObject(status.structure),
                                viewForCustomer: Utils.convertJSONDataToObject(status.viewForCustomer)
                            }))
                    } else {
                        statusTaskItemList = createSelectTypeTicketHasStatus
                        ? systemField.filter(field => field.usage === Constant.FORM_USAGE.STATUS)
                        : statusItemList
                    }

                    statusTaskItemList = statusTaskItemList.map(status => ({...status, structure: Utils.convertJSONDataToObject(status.structure)}))
                    let newStatus = statusTaskItemList.find(status => status.structure.no === Constant.STATUS_NO.TODO)
                    if (updateStatusWaiting) {
                        newStatus = statusTaskItemList.find(status => status.structure.no === Constant.STATUS_NO.WAITING)
                    }

                    setCurrentItemData({
                        ...newStatus,
                        no: newStatus?.structure?.no,
                        name: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, newStatus?.name),
                        background: newStatus?.structure?.helpdesk?.background,
                        color: newStatus?.structure?.helpdesk?.color
                    })
                    props.setIsEdited(true);
    
                    if (props.setStatusNo) {
                        props.setStatusNo(newStatus?.structure?.no)
                    }
                }
            }
        })()
    }, [props?.selectedAssigneeUserId, createSelectTypeTicketHasStatus, detailTicket, currentItemData])

    useEffect(() => {
        (async () => {
            if (createSelectTypeTicketHasStatus) {
                const fieldId = props.fieldData.id
                if (fieldId) {
                    const getListStatus = await getItemFieldListByFieldId(
                        props?.API,
                        Constant.FORM_USAGE.STATUS,
                        props?.fieldData?.affiliationOrganization,
                        fieldId
                    )
                    setStatusItemList(getListStatus);
                } else {
                    let statusTaskItemList = systemField.filter(field => field.usage === Constant.FORM_USAGE.STATUS)
                    setStatusItemList(statusTaskItemList.map(field => ({
                        ...field,
                        name: JSON.stringify(field.name),
                        structure: JSON.stringify(field.structure),
                        viewForCustomer: JSON.stringify(field.viewForCustomer)
                    })))
                }
                return;
            }
            const statusDetail = props?.statusDetail;
            const statusWorkflow = statusDetail?.workflow;
            const fieldAffiliationOrganization = props?.fieldData?.affiliationOrganization;
            if (fieldAffiliationOrganization && statusWorkflow) {
                getItemFieldListByFieldId(
                    props?.API,
                    Constant.FORM_USAGE.STATUS,
                    props?.fieldData?.affiliationOrganization,
                    statusDetail?.workflow
                ).then(listItem => {
                    setStatusItemList(listItem);
                });
            }
        })()
    }, [props.fieldData, props?.statusDetail?.workflow, props.isHelpDesk])

    useEffect(() => {
        // Fix for create ticket email screen
        if (props.panelType === Constant.PANEL_TYPE.ADD_TICKET && props.selectTicketType === Constant.HELPDESK_CREATE_TICKET_TYPE.EMAIL && currentItemData.no === Constant.STATUS_NO.WAITING) return;
        if (currentItemData?.id && currentItemData?.id !== props?.statusDetail?.status && !Utils.isEmpty(props?.statusDetail)) {
            props.setIsEdited(true);
            if (props.setIsEditTicket) {
                props.setIsEditTicket(true);
            }
            if (typeof props?.setShowButtonEditTicket === 'function') props?.setShowButtonEditTicket();
            if (props.setNewStatusOfTicket) {props.setNewStatusOfTicket(currentItemData.id);}
            if (props.setNewStatusData) {props.setNewStatusData(currentItemData)}
            if (!props?.listFieldEdited?.includes(props?.name)) {props?.setListFieldEdited([...props.listFieldEdited,props?.name])}
            if (props?.setOnChangeEdit) {props?.setOnChangeEdit(!props.onChangeEdit)}
        }

        updatePanelInitData(
            props.panelId,
            props.tabId,
            props.panelInitData,
            props.setPanelInitData,
            'ticketStatus',
            currentItemData
        );
    }, [currentItemData]);

    useEffect(()=>{
        return () => {
            setCurrentItemData({});
            setStatusItemList([]);
            setTicketStatusListPopover(null);
        }
    },[])

    useEffect(() => {
        if (props?.flagReset) {
            if (!props?.isEmail) {
                setCurrentItemData(props.currentItemData);
            }
            props.setFlagReset(false);
        }
    }, [props?.flagReset]);

    const useStyles = makeStyles(theme => {
        let background = `${currentItemData?.background}`;
        let color = `${currentItemData?.color}`;
       return { statusField: {
            color: color,
            background: background,
            cursor: `${!checkTicketEnableEdit() || currentItemData.no === Constant.STATUS_NO.WAITING ? 'context-menu !important' : 'pointer'}`
        } }
    });

    const classes = useStyles();

    const onClickHandler = event => {
        if (checkTicketEnableEdit() && currentItemData.no !== Constant.STATUS_NO.WAITING) {
            setTicketStatusListPopover(event.currentTarget);
            
        }
    };

    return (
        <div
            key={props.key}
            className={`form-addTicket form-addTicket-field-status 
                ${createSelectTypeTicketHasStatus || isDraftTicketTask ? ' form-addTicket-task-ticket-field-status' : ''}`
            }
        >
            <label className={`form-addTicket-label ${createSelectTypeTicketHasStatus || isDraftTicketTask ? ' form-addTicket-task-ticket-label' : ''}`}>
                <>
                    {I18n.get('STATUS_LABEL')} {detailTicket?.ticketType !== Constant.TICKET_TYPE.TELEPHONE ? <span className="required">*</span> : ''}
                </>
            </label>
            <>
                {currentItemData?.name && (
                    <OverFlowTooltipWithTabsMui
                        value={currentItemData?.name}
                        onClick={event => {
                            onClickHandler(event);
                        }}
                        id={idTicketStatusListPopover}
                        className={`${classes.statusField} status-ui`}
                    />
                )}
                <Popover
                    id={`change-ticket-status-${props.ticketDetail?.id || 'create_new_task_ticket_id'}`}
                    key={`change-ticket-status-${props.ticketDetail?.id || 'create_new_task_ticket_id'}`}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left'
                    }}
                    open={isTicketStatusListPopover && Utils.isEmptyString(props.ticketDetail?.deletedAt) && !props.isDisableEdit}
                    anchorEl={ticketStatusListPopover}
                    onClose={e => setTicketStatusListPopover(null)}
                >
                    <div className="ticket-status-list">
                        {renderStatusItemList(
                            statusItemList,
                            setCurrentItemData,
                            setTicketStatusListPopover,
                            currentItemData,
                            props.setStatusNo ? props.setStatusNo : () => {}
                        )}
                    </div>
                </Popover>
            </>
        </div>
    );
};
export default StatusFieldUI;

StatusFieldUI.propTypes = {
    isEmail: PropTypes.any,
    flagReset: PropTypes.any,
    currentItemData: PropTypes.any,
    setFlagReset: PropTypes.any
};
